import PageLayout from "../../components/common/page-layout";
import NotificationCutover from "../../components/notification-cutover/notification-cutover";
import { RequireAuth } from "../../hooks/use-auth";

/**
 * Route page for the notification engine cutover tool. Gates access behind
 * `RequireAuth` and renders the tool inside the shared page chrome.
 */
const NotificationCutoverPage = () => {
  return (
    <RequireAuth>
      <PageLayout
        subtitle="Flip notification events between the legacy path and the new engine"
        title="Notification cutover"
      >
        <NotificationCutover />
      </PageLayout>
    </RequireAuth>
  );
};

export default NotificationCutoverPage;
